import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function RecommendedMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.recommended("exclusive"));
  };

  return (
    <MainMenuItem
      itemTitleString="おすすめ商品"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default RecommendedMenuItem;
